import { cardActions } from './reducers';

export const { getCurrentCardAction, setCurrentCardAction, setCardErrorAction, clearCurrentCardAction } = cardActions;
